import { render, staticRenderFns } from "./PesquisaEscolhasAlimentares.vue?vue&type=template&id=aef5770c&scoped=true"
import script from "./PesquisaEscolhasAlimentares.vue?vue&type=script&lang=js"
export * from "./PesquisaEscolhasAlimentares.vue?vue&type=script&lang=js"
import style0 from "./PesquisaEscolhasAlimentares.vue?vue&type=style&index=0&id=aef5770c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef5770c",
  null
  
)

export default component.exports